import Api from './api';

const SaudeService = {
    cadastro: async (params) => {
        const response = await Api.post('/saude/cadastrar', params)
        return response
    },
    numDel: async (params) => {
        const response = await Api.get('/saude/delegados', params)
        return response
    },
    listarDocs: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/docsaude/listar',
            params: params
        })
        return response
    },
    buscarDocs: (params) => {
        const response = Api.get(`/docsaude/buscar?${params}`)
        return response
    },
    catDocs: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/docsaude/categorias',
            params: params
        })
        return response
    },
    listarProfs: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/profsaude/listar',
            params: params
        })
        return response
    },
    buscarProfs: (params) => {
        const response = Api.get(`/profsaude/buscar?${params}`)
        return response
    },
    listarLocs: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/locsaude/listar',
            params: params
        })
        return response
    },
    buscarLocs: (params) => {
        const response = Api.get(`/locsaude/buscar?${params}`)
        return response
    },
    listarRemume: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/remume/listar',
            params: params
        })
        return response
    },
    buscarRemume: (params) => {
        const response = Api.get(`/remume/buscar?${params}`)
        return response
    }
}

export default SaudeService;